// extracted by mini-css-extract-plugin
export default {"card_container":"card_card_container__SenMC","small_card_wrapper":"card_small_card_wrapper__T81iy","card":"card_card__kVWHz","card_small":"card_card_small__GznSf"};